import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MetaInfo from 'vue-meta-info' 
import VueVideoPlayer from 'vue-video-player'
import VueResource from 'vue-resource'
import Util from './assets/js/util'
import moment from 'moment'

//引入api接口
import ports from './api/index'
//引入画图组件
import echarts from 'echarts'
// 引入axios,axios不是vue家族的组件所以不能通过use方法安装，可以通过在vue对象上拓展原型方法来全局使用
import axios  from './until/axios'
// 引入elementUI并且全局安装
import Element from 'element-ui';
// import {MessageBox} from "element-ui"
// Vue.use(MessageBox);
// Vue.prototype.$msgbox = MessageBox


 
// 引入样式
import 'element-ui/lib/theme-chalk/index.css';

import COMMONFNC  from './components/utils/commonFuc.js';
// 引入转pdf文件
import htmlToPdf from './components/utils/htmlToPdf.js';
Vue.use(htmlToPdf)
Vue.use(VueVideoPlayer)
Vue.use(VueResource)
Vue.use(Util)
Vue.use(MetaInfo)

//定义公用css
import './style/application.scss'
// 安装elementUI
Vue.use(Element);
// 全局拓展axios
Vue.prototype.$ajax= axios;
Vue.prototype.ports = ports;

Vue.prototype.$moment= moment;
moment.locale('zh-cn')
//引入图标库
Vue.prototype.$echarts = echarts
/**
 * 反向代理配置
 * 通过prototype区分请求后端的接口地址
 */
Vue.prototype.G_uri     = '/papi';
Vue.prototype.G_uris    = '/api';
Vue.prototype.G_acapi   = '/acapi';
Vue.prototype.G_lcapi   = '/lcapi'
Vue.prototype.G_capi    = '/capi'
Vue.prototype.G_testuri = '/wapi';
Vue.prototype.G_report  = '/report/api';
Vue.prototype.COMMONFNC = COMMONFNC;

let token= window.sessionStorage.getItem('ymtxToken');
// window.sessionStorage.setItem('lct_token', token);
const localToken = window.localStorage.getItem('ymtxLocalToken')
if(!token && localToken) {
    window.sessionStorage.setItem('ymtxToken', localToken);
    // window.sessionStorage.setItem('lct_token', localToken);

}
let userType= window.sessionStorage.getItem('userType');
const localUserType = window.localStorage.getItem('localUserType')
if(!userType && localUserType) {
    window.sessionStorage.setItem('userType', localUserType);
}

window.addEventListener('storage', (e) => {
    if(!e.key) {
        if(!window.localStorage.getItem('ymtxLocalToken')) {
            window.sessionStorage.clear();
            // 退出的逻辑，给个弹框
            // alert('推出了')
            console.log(Element)
            Element.Message({
                message: '已有窗口退出，请勿再操作，刷新请重新登录！',
                type: 'error'
            });
            router.replace({path: '/login' })          
        }
    }
});
/**
 * 通过域名判断生产和测试使用的域名
 * $OEMdomain = 域名
 */
if(document.domain=='localhost' || document.domain=='39.98.37.134'){
    Vue.prototype.$OEMdomain="http://39.98.37.134";
}else{
    Vue.prototype.$OEMdomain= document.domain; 
    Vue.prototype.G_report='http://report.xuematech.com/api';//生产环境旧版生涯测评报告地址
}
 Vue.config.productionTip = false;
/*定义在全局 */
// 保留两位小数点
Vue.filter('toFixed', function (value, num) {
    value = Number(value);
    return value.toFixed(num);
});
// 向上取整
Vue.filter('ceil', function (value) {
    value = Number(value);
    return Math.ceil(value);
});

// 取绝对值
Vue.filter('abs', function (value) {
    value = Number(value);
    return Math.abs(value);
});
new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app');

// window.sessionStorage.zxsToken='e7c03d1247d675856a4b68a6697f17dc8184e581a35502a406087f9914812393'
// window.sessionStorage.ymtxToken='e7c03d1247d675856a4b68a6697f17dc8184e581a35502a406087f9914812393'
router.beforeResolve((to,from,next)=>{
    window.scroll(0,0)
    let role = sessionStorage.getItem('userType')
    if(to.meta&&to.meta.requireAuth){
        if (!window.sessionStorage.getItem("ymtxToken")) { // 判断当前的token是否存在
            next({path:'/login'});
        }else{
            if(to.meta.roles&&to.meta.roles.length&&to.meta.roles.length!==0){
                if(to.meta.roles.indexOf(role)>=0){
                    next()
                }else{
                    next({path:'/404'})
                }
            }
        }
    }else{
         next();
    }
})

